import classNames from "classnames";
import { format } from "date-fns";
import {nb as locale} from "date-fns/locale/nb";
import Link from "next/link";
import styles from "./ShowTime.module.css";

//#region [Props]
type ShowTimeProps = {
    ticketSaleUrl?: string | null;
    showStart: Date;
    dateOnly?: boolean;
};
//#endregion

//#region [Component]
export default function ShowTime({ ticketSaleUrl, showStart, dateOnly = false }: ShowTimeProps) {
    if (ticketSaleUrl) {
        return <Link href={ticketSaleUrl}>
            <time className={classNames(styles.ShowTime, dateOnly ? styles.ShowTimeDateOnly : "")}>
                <span className={styles.ShowTimeDate}>{format(showStart, "dd. MMM", { locale })}</span>
                {!dateOnly && <span className={classNames(styles.ShowTimeTime, styles.ShowTimeTime_link)}><span className={styles.ShowTime_Bg}>{format(showStart, "HH:mm", { locale })}</span></span>}
            </time>
        </Link>
    }
    return (<time className={classNames(styles.ShowTime, dateOnly ? styles.ShowTimeDateOnly : "")}>
        <span className={styles.ShowTimeDate}>{format(showStart, "dd. MMM", { locale })}</span>
        {!dateOnly && <span className={styles.ShowTimeTime}>{format(showStart, "HH:mm", { locale })}</span>}
    </time>);
}
//#endregion
